import reportActions from 'features/report/services/actions';
import React, { useEffect } from 'react';
import { useAppDispatch } from 'store/hooks';
import ReviewDashboard from './Dashboard';
import ReviewTable from './Table';
import styled from 'styled-components';
import colorTheme from 'constants/color';
import ReviewTableFilter from './Filter';

const ReviewReport = () => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(reportActions.initReviewReportParams());
  }, []);

  return (
    <ClockReportStyled>
      <ReviewTableFilter />
      <ReviewDashboard />
      <ReviewTable />
    </ClockReportStyled>
  );
};

export default ReviewReport;

const ClockReportStyled = styled.div`
  background-color: ${colorTheme.fill_3};
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;
